<div class="card purchase-card discover">
  <img class="img-fluid" src="assets/images/dashboard-2/discover.png" alt="vector discover" />
  <div class="card-body pt-3">
    <h5 class="mb-1">{{ 'Discover Pro' | translate }}</h5>
    <p class="f-light">{{ 'Amet minim mollit non deserunt ullamco est sit aliqua dolor' | translate }}</p>
    <a class="purchase-btn btn btn-hover-effect btn-primary f-w-500" href="https://1.envato.market/3GVzd" target="_blank">{{ 'Update Now' | translate }}</a>
  </div>
</div>
